module.exports = __webpack_public_path__ + "static/media/Government_Payment_Solution_by_Safexpay.33724f3c.pdf";